'use client';

import { Tooltip, TooltipContent, TooltipTrigger } from '@workspace/ui/components/tooltip';
import { useIsOverflowing } from '@workspace/ui/hooks';
import { cn } from '@workspace/ui/lib';
import type React from 'react';

interface TruncateWithTooltipProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

export const TruncateWithTooltip = ({
  children,
  className,
  contentClassName,
}: TruncateWithTooltipProps) => {
  const { ref, overflowing } = useIsOverflowing<HTMLSpanElement>();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={ref} className={cn('block min-w-0 truncate', className)}>
          {children}
        </span>
      </TooltipTrigger>
      {overflowing && (
        <TooltipContent className={cn('max-w-lg wrap-break-word px-3 py-2', contentClassName)}>
          {children}
        </TooltipContent>
      )}
    </Tooltip>
  );
};
